import { supabase } from './supabaseClient'

const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export async function registerPushNotifications(userId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('Push notifications not supported')
    return false
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js')
    await navigator.serviceWorker.ready

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      console.log('Notification permission denied')
      return false
    }

    if (!VAPID_PUBLIC_KEY) {
      console.warn('VITE_VAPID_PUBLIC_KEY not set — cannot subscribe to push')
      return false
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    })

    // push_subscriptions has split columns: endpoint, p256dh, auth. The
    // earlier upsert wrote a `subscription` jsonb column that doesn't
    // exist, so the row never landed and Edge-Function lookups got nothing
    // to send to. Pull the keys off the JSON shape directly.
    const json = subscription.toJSON()
    const { error } = await supabase
      .from('push_subscriptions')
      .upsert({
        user_id: userId,
        endpoint: json.endpoint,
        p256dh: json.keys?.p256dh,
        auth: json.keys?.auth,
      }, { onConflict: 'user_id' })

    if (error) {
      console.error('Failed to save subscription:', error)
      return false
    }

    console.log('Push notifications registered successfully')
    return true

  } catch (error) {
    console.error('Failed to register push notifications:', error)
    return false
  }
}

export async function unregisterPushNotifications(userId) {
  try {
    const registration = await navigator.serviceWorker.getRegistration('/sw.js')
    if (registration) {
      const subscription = await registration.pushManager.getSubscription()
      if (subscription) {
        await subscription.unsubscribe()
      }
    }

    await supabase
      .from('push_subscriptions')
      .delete()
      .eq('user_id', userId)

    return true
  } catch (error) {
    console.error('Failed to unregister:', error)
    return false
  }
}

export async function isPushRegistered() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return false
  }
  try {
    const registration = await navigator.serviceWorker.getRegistration('/sw.js')
    if (!registration) return false
    const subscription = await registration.pushManager.getSubscription()
    return !!subscription
  } catch {
    return false
  }
}
